import * as React from "react";
import { CommerceToolsApi } from "@grandvisionhq/commercetools";
import { LoaderScreen } from "@grandvisionhq/common";
import { useConfiguratorContext } from "@grandvisionhq/configurator";
import { Alert } from "@grandvisionhq/iris-ui";
import { useDispatch, useSelector, statusLoading, statusFailed, useIntl } from "@grandvisionhq/state";
import { useRxUploadStatus } from "../../../../hooks/hooks/use-rx-upload-status.js";
import "../../../../state/state/actions.js";
import { RX_SCOPE, PD_SCOPE } from "../../../../state/state/constants.js";
import "../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../state/bundles/state/bundles/selectors.js";
import "../../../../state/bundles/state/bundles/reducer.js";
import { getRxEntryTypes, getSelectedFrame, getPrescriptionType } from "../../../../state/configurator/state/configurator/selectors.js";
import "../../../../state/configurator/state/configurator/reducer.js";
import "../../../../state/products/state/products/selectors.js";
import "../../../../state/products/state/products/reducer.js";
import { isBookAppointmentEntrySelection } from "../../../../state/state/types.js";
import { isNewPrescriptionAndUpload } from "../../../../utils/utils/is-new-prescription-upload.js";
import { PrescriptionEntrySelectionStep } from "./PrescriptionEntrySelectionStep.js";
import { updatePrescriptionType } from "../../../../state/configurations/state/configurations/actions.js";
const PrescriptionEntrySelectionStepContainer = () => {
  const dispatch = useDispatch();
  const { goToNextStep } = useConfiguratorContext();
  let rxEntryTypes = useSelector(getRxEntryTypes);
  const frame = useSelector(getSelectedFrame);
  const prescriptionType = useSelector(getPrescriptionType);
  const hasUpload = !!rxEntryTypes?.some(({ key }) => key === "PrescriptionFile");
  const uploadStatus = useRxUploadStatus([RX_SCOPE, PD_SCOPE], hasUpload);
  const onChange = React.useCallback(
    (value) => {
      if (!frame) {
        return;
      }
      if (CommerceToolsApi.isPrescriptionType(value) || isBookAppointmentEntrySelection(value) || isNewPrescriptionAndUpload(value)) {
        dispatch(
          updatePrescriptionType({
            frameSku: frame.sku,
            prescriptionType: value,
            reason: "user selection"
          })
        );
      }
    },
    [dispatch, frame?.sku]
  );
  if (!frame || !rxEntryTypes || rxEntryTypes?.length === 0) {
    return /* @__PURE__ */ React.createElement(Failed, null);
  }
  if (statusLoading(uploadStatus)) {
    return /* @__PURE__ */ React.createElement(LoaderScreen, null);
  }
  if (statusFailed(uploadStatus)) {
    rxEntryTypes = rxEntryTypes.filter(({ key }) => key !== "PrescriptionFile");
  }
  return /* @__PURE__ */ React.createElement(
    PrescriptionEntrySelectionStep,
    {
      onChange,
      onSubmit: goToNextStep,
      itemsList: rxEntryTypes,
      selectedEntryItem: prescriptionType ? prescriptionType : rxEntryTypes[0].key
    }
  );
};
function Failed() {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(
    Alert,
    {
      variant: "error",
      title: getLabel("products.glasses.configurator.error"),
      className: "alert-m-default prescription-step__error"
    }
  );
}
export {
  PrescriptionEntrySelectionStepContainer
};
//# sourceMappingURL=PrescriptionEntrySelectionStepContainer.js.map
